const Home = () => (
  <div>
    <p>Use the menu to get started.</p>
  </div>
);

export default Home;
